import Splide from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';

document.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('.slider').forEach(el => {
		new Splide(el, {
			type: 'slide',
			perPage: 3,
			gap: '1rem',
			padding: {left: 'clamp(0px, (100vw - var(--normal-page-width)) / 2, 100vw)', right: '5rem'},
			focus  : 'center',
			pagination: false,
			lazyLoad: 'nearby',
			omitEnd: true,
			drag: true,
			arrows: true,
			breakpoints: {
				1024: { perPage: 2 },
				768: { perPage: 1 },
			},
		}).mount();
	});

	const announcementEl = document.getElementById('announcement-bar');
	if (announcementEl) {
		const list = announcementEl.querySelector('.splide__list');
		const original = list.querySelector('.splide__slide');
		for (let i = 0; i < 7; i++) {
			const clone = original.cloneNode(true);
			clone.setAttribute('aria-hidden', 'true');
			list.appendChild(clone);
		}

		new Splide(announcementEl, {
			type: 'loop',
			drag: 'free',
			arrows: false,
			pagination: false,
			autoWidth: true,
			gap: '3rem',
			autoScroll: {
				speed: 0.8,
				pauseOnHover: true,
			},
		}).mount({ AutoScroll });
	}

	document.querySelectorAll('.marquee').forEach(el => {
		new Splide(el, {
			type: 'loop',
			drag: 'free',
			focus: 'center',
			perPage: 5,
			gap: '1rem',
			arrows: false,
			pagination: false,
			autoScroll: {
				speed: 0.5,
				pauseOnHover: false,
			},
			breakpoints: {
				1024: { perPage: 3 },
				768: { perPage: 2 },
			},
		}).mount({ AutoScroll });
	});
});
